<template>
    <v-navigation-drawer
    fixed
    v-model="drawer"
    app
    width="300"
    id="appDrawer"
    >   
    <div align="center" style="margin-top:10px; margin-bottom:10px;">
        <img id="app-drawer-logo" @click="redirectToDashboard" src="https://cloud.conforma.si/public/img/kpss/logo-intro.png" alt="Nadzorni center - Ponastavitev gesla" width="auto" height="auto">
    </div>
    <v-divider></v-divider>
        <v-toolbar class="elevation-0 drawer-toolbar" color="white"  id="app_drawer_toolbar">
            <v-icon>language</v-icon>
            <v-toolbar-title class="ml-0 pl-3">
                <span class="">{{ app.drawerTitle }}</span>
            </v-toolbar-title>        
        </v-toolbar>
        <vue-perfect-scrollbar class="drawer-menu--scroll" :settings = "scrollSettings">
            <v-list dense expand>
                <template v-for="(item, i) in menus">
                <!--group with subitems-->
                <v-list-group v-if="item.items" :key="item.name" :group="item.group" :prepend-icon="item.icon" no-action="no-action">
                    <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                        <v-list-tile-title class="body-1">{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                    </v-list-tile>
                    <template v-for="(subItem, i) in item.items">
                        <!--sub group-->
                        <v-list-group v-if="subItem.items" :key="subItem.name"  sub-group no-action="no-action"> 
                        <v-list-tile slot="activator" ripple="ripple">
                            <v-list-tile-content>
                            <v-list-tile-title class="body-1">{{ subItem.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-for="(grand, i) in subItem.items" :key="i" :to="!grand.href ? { name: grand.name} : null" :href="grand.href" ripple="ripple">
                            <v-list-tile-content>
                            <v-list-tile-title class="body-1">{{ grand.title }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                            <v-icon v-text="'history'"></v-icon>
                        </v-list-tile-action>
                        </v-list-tile>
                        </v-list-group>
                        <!--child item-->
                        <v-list-tile v-else :key="i" :to="!subItem.href ? { name: subItem.name} : null" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                        <v-list-tile-content>
                            <v-list-tile-title class="body-1"><span>{{ subItem.title }}</span></v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="subItem.action">
                            <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                        </v-list-tile-action>
                        </v-list-tile>
                    </template>
                    </v-list-group>
                    <v-subheader v-else-if="item.header" :key="i"><v-icon></v-icon>{{ item.header }}</v-subheader>
                    <v-divider v-else-if="item.divider" :key="i"></v-divider>
                    <!--top-level link-->
                    <v-list-tile v-else :to="!item.href ? { name: item.name } : null" :href="item.href"  ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
                        <v-list-tile-action v-if="item.icon">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title class="body-1">{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="item.subAction">
                            <v-icon class="success--text">{{ item.subAction }}</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                </template>
                <v-list-tile @click="logout" ripple="ripple">
                    <v-list-tile-action>
                        <v-icon>lock_open</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="body-1">Odjava</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-spacer></v-spacer>
        </vue-perfect-scrollbar>

    </v-navigation-drawer>
</template>

<script>
import router from '@/router'
import menu from '@/helpers/menu'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    name: 'app-drawer',
    components: {
        router,
        VuePerfectScrollbar
    },

    props: {
      source: String
    },

    data: () => ({
        menus: menu,
        dialog: false,
        scrollSettings: {
            //maxScrollbarLength: 160
        }
    }),
    
    watch: {

    },

    computed: {
        user() {
            return this.$store.getters.user
        },

        drawer: {
            get() {
                return this.$store.getters.drawer
            },

            set(newValue) {
                this.$store.commit('SET_DRAWER', newValue)
            }
        },

        app() {
            return this.$store.getters.app
        }
    },

    methods: {
        logout() {
            this.$store.commit('SET_LOADER_TEXT', 'Odjava uporabnika je v teku...')
            this.$store.commit('SET_LOADER', true)

            this.$store.dispatch('LOGOUT')
            .then(response => {

                setTimeout(() => { 
                    this.$store.commit('SET_LOADER', false) 
                    router.push({
                        name: 'login'
                    })
                }, 800)
            })
            .catch(error =>{
                setTimeout(() => { this.$store.commit('SET_LOADER', false) }, 800),
                window.console.log('Logout error')
                window.console.log(error)

            })
        },

        redirect(path) {

        },

        genChildTarget (item, subItem) {
            if (subItem.href) return;
            if (subItem.component) {
                return {
                name: subItem.component,
                };
            }
            return { name: `${item.group}/${(subItem.name)}` };
        },

        redirectToDashboard() {
            if(this.$route.name != 'pregled') {
                this.$router.push({ name: 'pregled'})
            }
        }
    },

    created() {

    },

    mounted() {

    },

    destroyed() {

    }
}
</script>

<style>
    #appDrawer {
       overflow:hidden;
    }

    .drawer-menu--scroll {
        height: calc(100vh - 48px);
        overflow: auto; 
    }

    .drawer-toolbar {
        /*border-right: 1px solid rgba(0,0,0,.12) !important; */
    }

    .drawer-toolbar .v-toolbar__content {
        padding: 0 16px !important;
    }

    #app-drawer-logo {
        cursor: pointer !important;
    }

</style>




